// extracted by mini-css-extract-plugin
module.exports = {"img":"SecondLogo_img__1RCwS"};